import React, { useEffect } from "react";
import { Container, Row, Spinner } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import SalesByLocations from "../DashboardEcommerce/SalesByLocations";
import ApplicationsStatistic from "./ApplicationsStatistic";
import Candidates from "./Candidates";
import FeaturedCompanies from "./FeaturedCompanies";
import RecentApplicants from "./RecentApplicants";
import RecomendedJobs from "./RecomendedJobs";
import Widgets from "./Widgets";
import FeatherIcon from "feather-icons-react";
import { getDashboardData } from "../../slices/thunks";
import Revenue from "../DashboardEcommerce/Revenue";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";


const DashboardJobs = () => {
  const { t } = useTranslation();
  document.title = "Jobs Dashboard | Velzon - React Admin & Dashboard Template";
  const dispatch = useDispatch();

  const { Chats, isLoading } = useSelector(state => ({
    Chats: state.DashboardEcommerce.chatData,
    isLoading: state.DashboardEcommerce.loading,
  }));
  
  useEffect(() => {
    dispatch(getDashboardData());
  }, [])

  return (
    <React.Fragment>
      { isLoading ? <div className="d-flex justify-content-center align-items-center my-3">
          <Spinner
            style={{ height: "3rem", width: "3rem" }}
          >
            Loading...
          </Spinner>
        </div> :
        <div className="page-content">
          <Container fluid>
            <BreadCrumb title={t("Law Document")} pageTitle="Dashboards" />

            <Row>
              <Widgets />
              {/* <FeaturedCompanies /> */}
            </Row>

            <Row>
              <Revenue />
            </Row>

            <div className="row">
              {Chats.map((item, idx) => (
                <div className="col-lg-3" key={idx}>
                    <div className="card">
                        <div className="card-body d-flex gap-3 align-items-center">
                            <div className="avatar-sm">
                                <div className={`avatar-title border bg-${item.BgColor}-subtle border-${item.BgColor} border-opacity-25 rounded-2 fs-17`}>
                                    <FeatherIcon icon={item.Icon} className={`icon-dual-${item.BgColor}`}></FeatherIcon>
                                </div>
                            </div>
                            <div className="flex-grow-1">
                                <h5 className="fs-15">{item.Count}</h5>
                                <p className="mb-0 text-muted">{t(item.Label)}</p>
                            </div>
                        </div>
                    </div>
                </div>
              ))}
            </div>

            {/* <Row>
              <ApplicationsStatistic chartId="line_chart_dashed" />
              <Candidates />
            </Row>

            <Row>
              <RecomendedJobs />
            </Row>

            <Row>
              <RecentApplicants />
              <SalesByLocations />
            </Row> */}
          </Container>
        </div>
      }
    </React.Fragment>
  );
};

export default DashboardJobs;
